export default __webpack_public_path__ + "static/media/javascript.07314975.svg";